import type {DiffEntry} from '../../../conversation-types'
import {IconButton} from '@primer/react'
import {StaticUnifiedDiffPreview} from '../StaticUnifiedDiffPreview'
import styles from './AutomatedReviewDiffEntry.module.css'
import {useState} from 'react'
import {clsx} from 'clsx'
import {ChevronDownIcon, ChevronRightIcon} from '@primer/octicons-react'

export function AutomatedReviewDiffEntry({diffEntry}: {diffEntry: DiffEntry}) {
  const [isCollapsed, setIsCollapsed] = useState(false)
  const onToggleCollapsed = () => setIsCollapsed(!isCollapsed)

  return (
    <div key={diffEntry.path} className="d-flex flex-column overflow-hidden">
      <div
        className={clsx(
          'd-flex flex-items-center px-3 py-2 text-small gap-2 text-mono',
          styles.diffEntryHeader,
          isCollapsed && 'rounded-2',
        )}
      >
        <IconButton
          aria-label={isCollapsed ? 'Open review comment' : 'Close review comment'}
          icon={isCollapsed ? ChevronRightIcon : ChevronDownIcon}
          size="small"
          variant="invisible"
          onClick={onToggleCollapsed}
        />
        {diffEntry.path}
      </div>
      {!isCollapsed && (
        <StaticUnifiedDiffPreview
          // TODO(@aliceclv): pass tabSize dynamically
          tabSize={4}
          className={clsx('m-0 border-bottom borderColor-default overflow-hidden', styles.automatedReviewDiff)}
          diffTableClassName="borderColor-default"
          diffLines={diffEntry.diffLines}
        />
      )}
    </div>
  )
}

try{ AutomatedReviewDiffEntry.displayName ||= 'AutomatedReviewDiffEntry' } catch {}